import { render, staticRenderFns } from "./tipodelocal.vue?vue&type=template&id=2bd9d35a&"
import script from "./tipodelocal.vue?vue&type=script&lang=js&"
export * from "./tipodelocal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports